/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_BAN_RECONCILIATION_ITEM = {
  id: 'banks_reconciliation',
  screenId: 'fin-ban-reconciliation',
  label: 'Conciliación',
  description: 'Cotejo del extracto bancario con los movimientos del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Subís el extracto del banco (Excel o CSV) y lo comparás línea por línea con lo registrado en el sistema. Así marcás qué movimientos ya están conciliados y detectás diferencias.',
      },
      {
        title: 'Configuración previa (botón Config)',
        intro:
          'Antes de conciliar conviene revisar «Config». Ahí definís, para cada tipo de movimiento del extracto con estrategia Autoposteo, a qué centro de costo (gasto) se imputará cuando el sistema genere el movimiento automáticamente (comisiones, impuestos, intereses, etc.).',
        bullets: [
          'Conciliación — el movimiento se vincula a uno ya existente en el sistema.',
          'Autoposteo — el sistema puede crear el movimiento e imputarlo al gasto que indiques.',
          'Ignorar — no se procesa en conciliación automática.',
        ],
      },
      {
        title: 'Paso 1 — Listado de conciliaciones',
        fields: [
          { label: 'Cuenta bancaria', description: 'Cuenta sobre la que consultás conciliaciones.' },
          { label: 'Fecha desde / Fecha hasta', description: 'Período de las conciliaciones cargadas.' },
        ],
        bullets: [
          'Columnas: Fecha de carga, Mov desde, Mov hasta, Estado, Mov conciliados, Mov no conciliados.',
          'Estados posibles: Cargada, En edición, Confirmada.',
          'Tocá una fila para abrir el detalle y seguir conciliando.',
          'Las conciliaciones no confirmadas pueden eliminarse con el ícono de papelera (pedirá confirmación).',
        ],
      },
      {
        title: 'Paso 2 — Nueva conciliación',
        intro: 'El botón + abre la carga de extracto:',
        fields: [
          { label: 'Cuenta bancaria', description: 'Cuenta a conciliar.' },
          {
            label: 'Archivo',
            description:
              'Excel (.xlsx) o CSV separado por comas. Máximo 2 MB y 300 filas por archivo. Si tenés más líneas, dividí en varios archivos.',
          },
        ],
        paragraphs: [
          'Tocá «Crear Conciliación». Si el archivo es válido, entrás directo a la pantalla de emparejamiento de movimientos.',
        ],
      },
      {
        title: 'Paso 3 — Emparejar movimientos',
        intro: 'La grilla muestra dos bloques por fila: a la izquierda el extracto bancario; a la derecha el movimiento del sistema (si ya hay match).',
        bullets: [
          'Tocá una fila del extracto para abrir el detalle.',
          '«Asignar Conciliación» — buscá y elegí el movimiento del sistema que corresponde.',
          '«Eliminar Conciliación» — quitá un emparejamiento hecho.',
          'Las sugerencias automáticas pueden marcarse con «(IA)» al lado de la descripción.',
          '«Auto-conciliar (+ IA)» — intenta emparejar en lote con IA; puede demorar unos minutos. Podés salir de la pantalla: sigue en segundo plano y te avisamos al terminar.',
          '«Guardar Conciliación» — persiste los emparejamientos actuales.',
          'La flecha atrás vuelve al listado de conciliaciones.',
        ],
      },
      {
        title: 'Resultado en Movimientos',
        paragraphs: [
          'Cuando una línea queda conciliada, en Finanzas → Bancos → Movimientos la columna Conciliado pasa a «Sí» y ya no se puede eliminar desde ahí.',
        ],
      },
    ],
  },
}
